<template>
  <canvas class="banana_canvas" ref="refCanvas" :width="canvasWidth" :height="height"></canvas>
</template>

<script setup>
import { onMounted, ref } from 'vue'
const refCanvas = ref(null)
const canvasWidth = ref(window.innerWidth)

// canvas本地变量
var ctxWidth = null
var ctxHeight = null
defineProps({
  height: {
    type: String,
    default: 0
  }
})

onMounted(() => {
  loadCanvas()
})

// canvas动画
const loadCanvas = () => {
  window.onresize = function () {
    canvasWidth.value = window.innerWidth
  }
  ctxWidth = refCanvas.value.width
  ctxHeight = refCanvas.value.height
  let ctx = refCanvas.value.getContext('2d')
  let setArr = [] // 圆参数数组
  let maxNum = 200 // 圆数量
  // 绘制多个圆
  drawCircle(setArr, maxNum)
  // 绘制圆的运动
  ballDraw(ctx, setArr)
}

// 绘制多个圆
function drawCircle(setArr, maxNum) {
  let timer = requestAnimationFrame(function fn() {
    // 控制小球总数
    if (setArr.length >= maxNum) {
      cancelAnimationFrame(timer)
    } else {
      requestAnimationFrame(fn)
    }
    let cX = 200 + Math.ceil(Math.random() * ctxWidth) // 200--400  Math.ceil对浮点数向上取整
    let cY = 200 + Math.ceil(Math.random() * ctxHeight) // 初始Y坐标
    let r = 5 + Math.ceil(Math.random() * -5) // 半径5-12
    let red = Math.floor(Math.random() * 256) // 0--255
    let green = Math.floor(Math.random() * 256) // rgba
    let blue = Math.floor(Math.random() * 256)
    let alpha = 0.5 + Math.random() * 0.3 // 0.5--0.8 透明度
    // let color = `rgba(${red},${green},${blue},${alpha})`
    let color = `rgba(255,255,255,${alpha})`
    let sX = -1 + Math.ceil(Math.random() * 1.2) // -1 --- 5  x轴速度
    let sY = -1 + Math.ceil(Math.random() * 1.2)
    let obj = {
      cX: cX,
      cY: cY,
      r: r,
      red: red,
      green: green,
      blue: blue,
      alpha: alpha,
      sX: sX,
      sY: sY,
      bgColor: color
    }
    if (obj.sX !== 0 || obj.sY !== 0) {
      // 防止速度为0 ，不要静止的小球
      setArr.push(obj)
    }
  })
}

// 圆移动
function ballDraw(ctx, arr) {
  requestAnimationFrame(function fn() {
    // 绘制前要清空前一帧的画布
    ctx.clearRect(0, 0, canvasWidth.value, ctxHeight)
    arr.forEach((item) => {
      /* 边界碰撞处理 - 速度取反 */
      if (item.cX + item.r >= canvasWidth.value || item.cX - item.r <= 0) {
        // 碰到左右边界，反向弹
        item.sX *= -1
      }
      if (item.cY + item.r >= ctxHeight || item.cY - item.r <= 0) {
        // 碰到上下边界，反向弹
        item.sY *= -1
      }
      item.cX += item.sX
      item.cY += item.sY
      /* 绘制一个圆形 */
      ctx.beginPath()
      ctx.fillStyle = item.bgColor
      ctx.arc(item.cX, item.cY, item.r, 0, 2 * Math.PI)
      ctx.fill()
    })
    requestAnimationFrame(fn)
  })
}
</script>